import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import PropTypes from 'prop-types';
import HorizontalStack from 'Components/ComponentLibrary/Atoms/Layout/HorizontalStack';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import MessageTime from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageTime';

const useStyles = buildUseStyles('MessageHeader', ((theme) => ({
  senderName: {
    paddingRight: theme.spacing(1),
  },
})));

const MessageHeader = ({ messageResource }) => {
  const classes = useStyles();
  return (
    <HorizontalStack alignment={'centered'}>
      <StackItem>
        <Text
          className={classes.senderName}
          text={messageResource.attr('from')}
          color={'black'}
          weight={'bold'}
          variant={'h6'}
        />
      </StackItem>
      {messageResource.attr('fromEmailAddress')
        ? (
          <StackItem>
            <Text
              className={classes.senderName}
              text={`<${messageResource.attr('fromEmailAddress')}>`}
              color={'darkGray'}
              variant={'h6'}
            />
          </StackItem>) : null }
      <StackItem>
        <MessageTime messageResource={messageResource} />
      </StackItem>
    </HorizontalStack>
  );
};

MessageHeader.propTypes = {
  messageResource: PropTypes.object.isRequired,
};

export default MessageHeader;
